import React from 'react';

const Contact: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Contact</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Nous sommes à votre écoute pour toute question ou information
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
              <div>
                <h2 className="text-2xl font-bold mb-6 text-primary">Nos coordonnées</h2>
                
                <div className="mb-8">
                  <h3 className="text-xl font-bold mb-3">Siège social</h3>
                  <address className="not-italic">
                    <p className="mb-2">États-Unis / État du Maryland</p>
                    <p className="mb-2">
                      <strong>Téléphone:</strong><br />
                      +1(347) 591-8720<br />
                      +1(347) 469 2799
                    </p>
                  </address>
                </div>
                
                <div className="mb-8">
                  <h3 className="text-xl font-bold mb-3">Représentation Côte d'Ivoire</h3>
                  <address className="not-italic">
                    <p className="mb-2">Abidjan—Cocody—Angré</p>
                    <p className="mb-2">
                      <strong>Téléphone:</strong><br />
                      00225 07 59 98 34 89
                    </p>
                  </address>
                </div>
                
                <div className="mb-8">
                  <h3 className="text-xl font-bold mb-3">Email</h3>
                  <p>
                    <a href="mailto:morelovedm@gmail.com" className="text-primary hover:underline">
                      morelovedm@gmail.com
                    </a>
                  </p>
                </div>
                
                <div>
                  <h3 className="text-xl font-bold mb-3">Horaires</h3>
                  <p className="mb-2">
                    <strong>Lundi - Vendredi:</strong> 9h00 - 17h00
                  </p>
                  <p>
                    <strong>Samedi:</strong> 10h00 - 14h00 (sur rendez-vous)
                  </p>
                </div>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold mb-6 text-primary">Formulaire de contact</h2>
                <form className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                      Nom complet
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
                      Sujet
                    </label>
                    <input
                      type="text"
                      id="subject"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                      Message
                    </label>
                    <textarea
                      id="message"
                      rows={6}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    ></textarea>
                  </div>
                  
                  <div>
                    <button type="submit" className="btn-primary">
                      Envoyer le message
                    </button>
                  </div>
                </form>
              </div>
            </div>
            
            <div className="text-center">
              <h2 className="text-2xl font-bold mb-6 text-primary">Rejoignez notre mission</h2>
              <p className="mb-8 max-w-2xl mx-auto">
                Que ce soit par un don, en devenant membre, ou en partageant notre mission, 
                votre soutien est précieux pour nous aider à faire une différence dans la vie 
                des femmes et des enfants.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <a href="/donate" className="btn-donate">Faire un don</a>
                <a href="/membership" className="btn-secondary">Devenir membre</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
